import styled, { css } from "styled-components";
import {
  getNewLookTokens,
  NEW_LOOK_FIGURE_WEIGHT,
  newLookPhoneType,
} from "common/NewLook/tokens.ts";

/** Row parts shared by the phone portfolio lists (accounts, assets, positions). */
export const PhoneRow = styled.div`
  display: flex;
  align-items: center;
  /* Tight enough to leave the name its full width. */
  gap: 10px;
  cursor: pointer;
  outline: none;
  &:focus-visible {
    box-shadow: 0 0 0 2px ${(p) => getNewLookTokens(p.theme).focus};
    border-radius: 8px;
  }
`;
export const PhoneNames = styled.div`
  flex: 1;
  min-width: 0;
  line-height: 1.3;
`;
export const PhoneNameLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 6px;
  min-width: 0;
  /* One line: the pair keeps its full name, and a side pill that no longer
     fits wraps out of sight instead of squeezing it. */
  height: 20px;
  overflow: hidden;
`;
/**
 * A row's name (15/500). `$wrap`: a long name takes a second line rather
 * than an early ellipsis (names are the row's id).
 */
export const PhoneName = styled.div<{ $wrap?: boolean }>`
  ${newLookPhoneType.cardTitle};
  font-variant-numeric: tabular-nums;
  color: ${(p) => getNewLookTokens(p.theme).ink};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${(p) =>
    p.$wrap &&
    css`
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      white-space: normal;
      overflow-wrap: anywhere;
    `}
`;
export const PhoneMeta = styled.div`
  ${newLookPhoneType.meta};
  color: ${(p) => getNewLookTokens(p.theme).muted};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Quantities come from shared text components with their own sizes. */
  * {
    font-size: inherit !important;
    color: inherit !important;
  }
`;
export const PhoneAmounts = styled.div`
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;
/** A row's figure: the name's size, a step lighter, tabular. */
export const PhoneFigure = styled.span`
  ${newLookPhoneType.rowFigure};
  color: ${(p) => getNewLookTokens(p.theme).ink};
  white-space: nowrap;
`;
export const PhoneSub = styled.span`
  ${newLookPhoneType.meta};
  font-weight: ${NEW_LOOK_FIGURE_WEIGHT};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;
export const PhoneActions = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  margin-right: -8px;
  color: ${(p) => getNewLookTokens(p.theme).secondary};
`;
/** Keeps the actions' column when the row has none (read-only users). */
export const PhoneActionsSpacer = styled.div`
  flex: none;
  width: 8px;
`;
